"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRODUCT_TYPE = {
    FX_SPOT: 'FX_SPOT',
};
var SIDE;
(function (SIDE) {
    SIDE["BUY"] = "buy";
    SIDE["SELL"] = "sell";
})(SIDE = exports.SIDE || (exports.SIDE = {}));
;
exports.REASON_SCOPE = {
    MARKET: 'MARKET',
    TRADER: 'TRADER',
    SALES: 'SALES',
};
exports.REASON_TYPE = {
    SYSTEM: 'SYSTEM',
    CLIENT: 'CLIENT',
    LIMITS: 'LIMITS',
    SOURCE: 'SOURCE',
    CONFIG: 'CONFIG',
};
exports.REASON_VISABILITY = {
    DEFAULT: 'DEFAULT',
    INTERNAL: 'INTERNAL',
    PUBLIC: 'PUBLIC',
};
var QUOTE_STATE;
(function (QUOTE_STATE) {
    QUOTE_STATE["UNKNOWN"] = "UNKNOWN";
    QUOTE_STATE["OFF"] = "OFF";
    QUOTE_STATE["ERROR"] = "ERROR";
    // Clients should typically not observe pending values
    QUOTE_STATE["PENDING"] = "PENDING";
    QUOTE_STATE["STALE"] = "STALE";
    QUOTE_STATE["INDICATIVE"] = "INDICATIVE";
    QUOTE_STATE["DEALABLE"] = "DEALABLE";
})(QUOTE_STATE = exports.QUOTE_STATE || (exports.QUOTE_STATE = {}));
;
